import { Client } from "creso-core/types";
import {
  buttonVariants,
  cn,
  Dialog,
  DialogContent,
  DialogTrigger,
} from "web-design-system";
import { GiftOutboundTransaction } from "./gift-outbound-transaction";

export function GiftTrigger({ client }: { client: Client }) {
  return (
    <Dialog>
      <DialogTrigger className={cn(buttonVariants({ variant: "outline" }))}>
        Start
      </DialogTrigger>
      <DialogContent className="p-5 max-w-none w-110 h-150">
        <GiftOutboundTransaction client={client} />
      </DialogContent>
    </Dialog>
  );
}
